export const OrganizationPermissionEditorKey = 'organization-permission-editor';
export const OrganizationPermissionAssertionKey = 'assert-org-permission';
//# sourceMappingURL=consts.js.map